import type { ImageSourcePropType } from "react-native";
import {
  avatarIdFromPhotoURL,
  isRemoteAvatarPhotoURL,
  type NeqrawDefaultAvatarId,
} from "../lib/avatarPresets";

export type { NeqrawDefaultAvatarId } from "../lib/avatarPresets";

export const neqrawDefaultAvatars: readonly {
  id: NeqrawDefaultAvatarId;
  source: ImageSourcePropType;
}[] = [
  { id: "boy-01", source: require("@/assets/brand/avatars/avatar-boy-01.png") },
  { id: "boy-02", source: require("@/assets/brand/avatars/avatar-boy-02.png") },
  { id: "girl-hijab", source: require("@/assets/brand/avatars/avatar-girl-hijab.png") },
  { id: "girl-02", source: require("@/assets/brand/avatars/avatar-girl-02.png") },
] as const;

export function defaultAvatarFor(seed: string) {
  const index = Array.from(seed).reduce((total, character) => total + character.codePointAt(0)!, 0)
    % neqrawDefaultAvatars.length;
  return neqrawDefaultAvatars[index];
}

export function avatarSourceFor(photoURL: unknown, seed: string): ImageSourcePropType {
  const presetId = avatarIdFromPhotoURL(photoURL);
  if (presetId) {
    return neqrawDefaultAvatars.find((avatar) => avatar.id === presetId)?.source
      ?? defaultAvatarFor(seed).source;
  }

  if (isRemoteAvatarPhotoURL(photoURL)) {
    return { uri: photoURL.trim() };
  }

  return defaultAvatarFor(seed).source;
}
